import './contactsJourney.scss';
import { DashboardMenuFeatures } from '../DashboardMenuFeatures';
import { ContactsJourneyFeatures } from './ContactsJourneyFeatures';
import { dashboardGeneralStateName } from '..';
import { DATA_SOURCE } from '../services/ContactsJourneyService';
import { groupBy } from 'data/array';
import { FAILURE_STATUS, SUCCESS_STATUS } from 'modules/application/misc/SegmentService';
import { setupDaterangePickerPeriod, setupPeriodToCookies } from 'modules/analytics/Utils';
import moment from 'moment';
import { ContactsJourneyInfoModalControler } from './contactsJourneyInfoModal/ContactsJourneyInfoModalControler';
import ContactsJourneyInfoModalView from './contactsJourneyInfoModal/ContactsJourneyInfoModalView.html';
import permissions from 'application/detail/permissions.json';
import ContactsJourneySideBarView from './ContactsJourneySideBarView.html';
import { ContactsJourneySideBarController } from './ContactsJourneySideBarController';
import { createJourneyTrack } from './utils/contactsJourneyUtils';
import { APPLICATION_EMPTY_DATA_DESCRIPTION, AUTO_TRACKING_ERROR, BEHAVIOR_DISPLAYED, BEHAVIOR_EXCEPTION, CONTACTS_LISTED_TRACK, CONTACTS_SIDE_BAR_ID, DATE_CHANGED_TRACK, DEFAULT_DATE_FORMAT, DIAGRAM_BEHAVIOR_TRACK, FIRST_NODE_CHANGED_TRACK, FULL_WIDTH, GERNERIC_ERROR, INFO_MODAL_TRACK, MASTER_EMPTY_DATA_DESCRIPTION, MAX_NODES_PER_STEP_FILTER, MAX_STEPS_FILTER, MAXIMUM_DAYS_TO_SELECT_FROM_TODAY, MOVED_SCROLL_TRACK, NO_DATA_FOUND_ERROR, ONE_STEP_WIDTH, PERIOD_RANGE_MAX, PERIOD_RANGE_MIN, PERIOD_TODAY, PERIOD_YESTERDAY, SANKEY_CHANGE_EVENT, SANKEY_OPTIONS, STATE_ID_START, STATE_NAME_NODE_EXIT, STATE_NAME_NODE_OTHERS, } from './Constants';
export var LoadType;
(function (LoadType) {
    LoadType[LoadType["Filter"] = 0] = "Filter";
    LoadType[LoadType["Chart"] = 1] = "Chart";
})(LoadType || (LoadType = {}));
export class ContactsJourneyController {
    static $inject = ['ModalService', '$state', 'ContactsJourneyService', '$rootScope', '$timeout', 'SegmentService', '$cookies', 'TranslateService', 'BuilderService', 'ApplicationService2', 'SidebarContentService', '$document', '$scope'];
    constructor(ModalService, $state, ContactsJourneyService, $rootScope, $timeout, SegmentService, $cookies, TranslateService, BuilderService, ApplicationService2, SidebarContentService, $document, $scope) {
        'ngInject';
        this.ModalService = ModalService;
        this.$state = $state;
        this.ContactsJourneyService = ContactsJourneyService;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.SegmentService = SegmentService;
        this.$cookies = $cookies;
        this.TranslateService = TranslateService;
        this.BuilderService = BuilderService;
        this.ApplicationService2 = ApplicationService2;
        this.SidebarContentService = SidebarContentService;
        this.$document = $document;
        this.$scope = $scope;
        this.isShowingContactsJourney = false;
        this.isShowingContactsButton = false;
        this.isContactsButtonAvailable = false;
        this.allJourneyEdges = [];
        this.displayedJourneyEdges = [];
        this.containerId = 'sankey-chart';
        this.changeEvent = SANKEY_CHANGE_EVENT;
        this.sankeyOptions = SANKEY_OPTIONS;
        this.isLoading = true;
        this.automaticTrackingActive = false;
        this.noDataFound = false;
        this.genericError = false;
        this.isMasterApplication = false;
        this.displayEmptyMasterMessage = false;
        this.noDataDescription = APPLICATION_EMPTY_DATA_DESCRIPTION;
        this.stepsCount = 0;
        this.labeledColorCardsInfo = [];
        this.isShowingCSVExportButton = false;
        this.isUsingCassandraDataSource = false;
        this.isShowingFirstNodeFilter = false;
        this.doNotTrackNextDateChange = true;
        this.applyFirstNodeFilter = (event) => {
            this.SegmentService.createBotTrack(FIRST_NODE_CHANGED_TRACK, this.$rootScope.application);
            this.firstNode = event.detail?.value;
            this.applyFilter();
        };
        this.cookiesPeriodKey = `${this.$rootScope.application.shortName}_contactsJourneyPeriodSetting`;
    }
    async $onInit() {
        this.currentUserPermissions = await this.getCurrentUserPermissions();
        await this.checkFeatures();
        this.isMasterApplication = this.ApplicationService2.isThisMasterApplication(this.$rootScope.application);
        if (!this.isMasterApplication) {
            await this.checkAutomaticTrackingEnabled();
        }
        this.initAndApplyFilter();
        this.setLabeledColorCards();
        this.listenToSelectedEdgeChange();
    }
    async getCurrentUserPermissions() {
        return Object.keys(permissions).reduce((object, permissionName) => ({
            ...object,
            [permissionName]: this.$rootScope.application.applicationUserPermissionModel.some((p) => p.permissionClaim === permissions[permissionName].claim),
        }), {});
    }
    isUserAllowedToViewContacts() {
        return this.currentUserPermissions.users;
    }
    async showContactsJourneyInfoModalModal() {
        createJourneyTrack(this.SegmentService, this.$rootScope.application, INFO_MODAL_TRACK);
        const modal = await this.ModalService.showModal({
            template: ContactsJourneyInfoModalView,
            controller: ContactsJourneyInfoModalControler,
            controllerAs: '$ctrl',
        });
        await modal.close;
    }
    listenForDiagramScrollUsage() {
        const diagramElement = document.getElementById('contacts-journey-content');
        let eventTimer;
        diagramElement.addEventListener('scroll', (event) => {
            clearTimeout(eventTimer);
            const maxScrollLeft = diagramElement.scrollWidth - diagramElement.clientWidth;
            const xAxisPosition = diagramElement.scrollLeft;
            if (xAxisPosition > 0) {
                eventTimer = setTimeout(() => {
                    this.trackPercentageDisplayed(xAxisPosition, maxScrollLeft);
                }, 1500);
            }
        });
    }
    trackPercentageDisplayed(xAxisPosition, maxScrollLeft) {
        const percentageDisplayed = (xAxisPosition / maxScrollLeft) * 100;
        createJourneyTrack(this.SegmentService, this.$rootScope.application, MOVED_SCROLL_TRACK, {
            stepsCount: this.stepsCount,
            percentageDisplayed: Math.round(percentageDisplayed),
        });
    }
    async checkAutomaticTrackingEnabled() {
        try {
            this.automaticTrackingActive = await this.BuilderService.isAutomaticTrackingPublished();
        }
        catch (e) {
            console.error(`Error while getting published flow data: ${e}`);
        }
        finally {
            if (!this.automaticTrackingActive) {
                this.setIsLoading(false);
                const behaviorTrackObject = {
                    behavior: BEHAVIOR_EXCEPTION,
                    exception: AUTO_TRACKING_ERROR,
                };
                createJourneyTrack(this.SegmentService, this.$rootScope.application, DIAGRAM_BEHAVIOR_TRACK, behaviorTrackObject);
            }
        }
    }
    async checkFeatures() {
        this.isShowingContactsJourney = await DashboardMenuFeatures.isShowingContactsJourney();
        if (!this.isShowingContactsJourney) {
            this.$state.go(dashboardGeneralStateName);
        }
        this.isShowingContactsButton = await ContactsJourneyFeatures.isShowingContactsButton();
        this.isShowingCSVExportButton = await ContactsJourneyFeatures.isShowingCSVExportButton();
        this.isUsingCassandraDataSource = await ContactsJourneyFeatures.isUsingCassandraDataSource();
        this.isShowingFirstNodeFilter = await ContactsJourneyFeatures.isShowingFirstNodeFilter();
    }
    async loadFirstNodeFilterData(searchPeriod) {
        const allJourneyEdges = await this.getJourneyEdges(searchPeriod, this.firstNode, LoadType.Filter);
        this.firstNodeFilterOptions = this.firstNodeFilterOptions ?? this.getFirstNodeFilterOptionsJson(allJourneyEdges);
        if (allJourneyEdges.length === 0) {
            this.noDataFound = true;
            this.trackBehaviorException(NO_DATA_FOUND_ERROR);
        }
    }
    async loadChartData(searchPeriod) {
        this.allJourneyEdges = await this.getJourneyEdges(searchPeriod, this.firstNode, LoadType.Chart);
        this.displayEmptyMasterMessage = this.isMasterApplication && this.allJourneyEdges.length === 0;
        this.noDataDescription = this.displayEmptyMasterMessage ? MASTER_EMPTY_DATA_DESCRIPTION : APPLICATION_EMPTY_DATA_DESCRIPTION;
        if (this.allJourneyEdges.length === 0) {
            this.noDataFound = true;
            this.trackBehaviorException(NO_DATA_FOUND_ERROR);
        }
        else {
            this.noDataFound = false;
            this.displayEmptyMasterMessage = false;
            this.$timeout(() => {
                this.listenForDiagramScrollUsage();
                this.updateJourneyData();
            });
            createJourneyTrack(this.SegmentService, this.$rootScope.application, DIAGRAM_BEHAVIOR_TRACK, { behavior: BEHAVIOR_DISPLAYED });
        }
    }
    handleLoadDataError(loadType, error) {
        this.genericError = true;
        this.trackBehaviorException(GERNERIC_ERROR);
        console.error(`Error loading data for ${loadType === LoadType.Filter ? 'firstNodeFilter' : 'sankeyChart'}: `, error);
    }
    trackBehaviorException(exception) {
        const behaviorTrackObject = {
            behavior: BEHAVIOR_EXCEPTION,
            exception,
        };
        createJourneyTrack(this.SegmentService, this.$rootScope.application, DIAGRAM_BEHAVIOR_TRACK, behaviorTrackObject);
    }
    async loadData(loadType) {
        const { startDate, endDate } = this.daterangePickerPeriod.selectedPeriod;
        const searchPeriod = {
            startDate,
            endDate,
        };
        try {
            if (loadType === LoadType.Filter) {
                await this.loadFirstNodeFilterData(searchPeriod);
            }
            else if (loadType === LoadType.Chart) {
                await this.loadChartData(searchPeriod);
            }
        }
        catch (e) {
            this.handleLoadDataError(loadType, e);
        }
    }
    async getJourneyEdges(searchPeriod, firstNode = STATE_ID_START, loadType = LoadType.Chart) {
        let allJourneyEdges = [];
        if (this.automaticTrackingActive || this.isMasterApplication) {
            this.dataSource = DATA_SOURCE.CASSANDRA;
            if (loadType === LoadType.Chart) {
                allJourneyEdges = await this.ContactsJourneyService.getJourneyEdges(searchPeriod, this.dataSource, firstNode);
            }
            else if (loadType === LoadType.Filter) {
                allJourneyEdges = await this.ContactsJourneyService.getJourneyEdges(searchPeriod, this.dataSource, firstNode, MAX_STEPS_FILTER, MAX_NODES_PER_STEP_FILTER);
            }
        }
        if (allJourneyEdges.length === 0 && !this.isUsingCassandraDataSource) {
            this.dataSource = DATA_SOURCE.SQL;
            if (loadType === LoadType.Chart) {
                allJourneyEdges = await this.ContactsJourneyService.getJourneyEdges(searchPeriod, this.dataSource, firstNode);
            }
            else if (loadType === LoadType.Filter) {
                allJourneyEdges = await this.ContactsJourneyService.getJourneyEdges(searchPeriod, this.dataSource, firstNode, MAX_STEPS_FILTER, MAX_NODES_PER_STEP_FILTER);
            }
        }
        return allJourneyEdges;
    }
    getFirstNodeFilterOptionsJson(edges) {
        const nodes = this.convertEdgesToNodeOptions(edges);
        const uniqueNodes = this.filterUniqueNodes(nodes);
        const sortedNodes = uniqueNodes.sort((a, b) => a.label > b.label ? 1 : -1);
        return JSON.stringify(sortedNodes);
    }
    getNodeNameWithoutInstance(nameWithInstance) {
        return nameWithInstance.substring(0, nameWithInstance.lastIndexOf('[') - 1);
    }
    convertEdgesToNodeOptions(edges) {
        return edges
            .map(x => ({ 'label': this.getNodeNameWithoutInstance(x.from), 'value': x.fromStateId }))
            .filter(x => ![STATE_NAME_NODE_OTHERS, STATE_NAME_NODE_EXIT].includes(x.label) && x.value !== STATE_ID_START);
    }
    filterUniqueNodes(nodes) {
        return nodes.filter((item, index) => nodes.findIndex(e => e.label === item.label) === index);
    }
    updateJourneyData() {
        this.displayedJourneyEdges = this.normalizeEdgesToDisplay(this.allJourneyEdges);
        const groupedSteps = groupBy(this.allJourneyEdges, 'step');
        this.stepsCount = Object.keys(groupedSteps).length;
        this.updateJourneyView();
    }
    normalizeEdgesToDisplay(displayedEdges) {
        const exitName = this.TranslateService.instantTranslate('contactsJourney.exit');
        const othersName = this.TranslateService.instantTranslate('contactsJourney.othersNodeName');
        displayedEdges.forEach((edge) => {
            edge.to = edge.to
                .replace(STATE_NAME_NODE_OTHERS, othersName)
                .replace(STATE_NAME_NODE_EXIT, exitName);
            edge.from = edge.from
                .replace(STATE_NAME_NODE_OTHERS, othersName)
                .replace(STATE_NAME_NODE_EXIT, exitName);
        });
        return displayedEdges;
    }
    adjustJourneyViewWidth() {
        const viewWidth = ONE_STEP_WIDTH * this.stepsCount;
        const normalizedWidth = viewWidth < FULL_WIDTH ? FULL_WIDTH : viewWidth;
        const diagramElement = document.getElementById('diagram-body');
        if (diagramElement) {
            diagramElement.style.width = `${normalizedWidth}%`;
        }
    }
    updateJourneyView() {
        this.$timeout(() => {
            this.adjustJourneyViewWidth();
            this.$rootScope.$broadcast(this.changeEvent, this.containerId);
        });
    }
    initAndApplyFilter() {
        const periodConstants = {
            defaultStartFromToday: PERIOD_YESTERDAY,
            defaultEndFromToday: PERIOD_TODAY,
            validStartFromToday: PERIOD_RANGE_MIN,
            validEndFromToday: PERIOD_RANGE_MAX,
            maximumDaysToSelect: MAXIMUM_DAYS_TO_SELECT_FROM_TODAY,
        };
        const hasTime = false;
        /* When 'this.dateRangePickerPeriod' receives its value, the 'blip-daterange-picker' calls 'this.applyDateRangeFilter()' and the search is made.
        This is defined in attribute 'on-date-selection' inside 'blip-daterange-picker'*/
        this.daterangePickerPeriod = setupDaterangePickerPeriod(periodConstants, this.$cookies, this.cookiesPeriodKey, hasTime);
    }
    applyDateRangeFilter() {
        if (this.doNotTrackNextDateChange) {
            this.doNotTrackNextDateChange = false;
        }
        else {
            this.SegmentService.createBotTrack(DATE_CHANGED_TRACK, this.$rootScope.application);
        }
        this.firstNodeFilterOptions = undefined;
        this.firstNode = undefined;
        this.applyFilter();
    }
    applyFilter() {
        this.genericError = false;
        this.noDataFound = false;
        this.displayEmptyMasterMessage = false;
        this.setIsLoading(true);
        this.isLoading = true;
        this.displayedJourneyEdges = [];
        this.updateJourneyView();
        const start = moment(this.daterangePickerPeriod.selectedPeriod.startDate)
            .format(DEFAULT_DATE_FORMAT);
        const end = moment(this.daterangePickerPeriod.selectedPeriod.endDate)
            .format(DEFAULT_DATE_FORMAT);
        const periodToCookies = {
            start,
            end,
        };
        setupPeriodToCookies({
            $cookies: this.$cookies,
            period: periodToCookies,
            key: this.cookiesPeriodKey,
        });
        this.loadData(LoadType.Chart);
        this.loadData(LoadType.Filter);
        this.setIsLoading(false);
    }
    canShowDiagram() {
        return this.isShowingContactsJourney
            && !this.isLoading
            && !this.canShowNoDataView()
            && !this.canShowGenericError();
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    setLabeledColorCards() {
        const cards = [
            { type: 'default', color: 'colorPrimary' },
            { type: 'exit', color: 'colorExit' },
            { type: 'other', color: 'colorSurface4' },
        ];
        this.labeledColorCardsInfo = cards.map(card => ({
            title: `contactsJourney.instructions.nodes.${card.type}.title`,
            color: card.color,
            text: `contactsJourney.instructions.nodes.${card.type}.description`,
        }));
    }
    async openContactsSideBar() {
        let behavior = SUCCESS_STATUS;
        try {
            this.isContactsButtonAvailable && await this.SidebarContentService.showSidebar({
                controller: ContactsJourneySideBarController,
                template: ContactsJourneySideBarView,
                controllerAs: '$ctrl',
                appendToElement: this.$document[0].getElementById('main-content-area'),
                inputs: {
                    selectedEdge: this.selectedEdge,
                    searchPeriod: this.daterangePickerPeriod.selectedPeriod,
                    dataSource: this.dataSource,
                    firstNode: this.firstNode,
                    application: this.$rootScope.application,
                    selectedNodeUsersCount: this.selectedNodeUsersCount,
                    isShowingCSVExportButton: this.isShowingCSVExportButton,
                },
                sidebarId: CONTACTS_SIDE_BAR_ID,
            });
        }
        catch (e) {
            behavior = FAILURE_STATUS;
        }
        finally {
            createJourneyTrack(this.SegmentService, this.$rootScope.application, CONTACTS_LISTED_TRACK, {
                behavior,
                nodeType: this.selectedEdge.type,
                nodeName: this.selectedEdge.name,
            });
        }
    }
    listenToSelectedEdgeChange() {
        this.$scope.$watch('$ctrl.selectedEdge', () => {
            this.SidebarContentService.cleanAndClose(false);
        });
    }
    canShowLoading() {
        return this.isLoading;
    }
    canShowNoDataView() {
        return !this.canShowLoading() && (this.noDataFound || this.displayEmptyMasterMessage);
    }
    canShowEmptyMasterApplicationMessage() {
        return this.displayEmptyMasterMessage;
    }
    canShowGenericError() {
        return this.genericError;
    }
    canShowHeader() {
        return this.canShowDiagram() || this.canShowNoDataView();
    }
    canCurrentUserViewContacts() {
        return this.isShowingContactsButton
            && this.isUserAllowedToViewContacts();
    }
}
ContactsJourneyController.$inject = ['ModalService', '$state', 'ContactsJourneyService', '$rootScope', '$timeout', 'SegmentService', '$cookies', 'TranslateService', 'BuilderService', 'ApplicationService2', 'SidebarContentService', '$document', '$scope'];
